import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "report-messages" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Messages ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "report-section-header__heading__privacy-message" }, " Privacy filter has been applied ", -1)
const _hoisted_4 = { class: "report-messages__headings row" }
const _hoisted_5 = { class: "cell col-2 col-md-2" }
const _hoisted_6 = { class: "cell content col-10 col-md-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationTag = _resolveComponent("NotificationTag")!
  const _component_ReportSectionHeader = _resolveComponent("ReportSectionHeader")!
  const _component_GenericTableHeaderButton = _resolveComponent("GenericTableHeaderButton")!
  const _component_ReportSectionObserver = _resolveComponent("ReportSectionObserver")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ReportSectionHeader, {
      onFilterToggled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAccordion())),
      isOpen: _ctx.isOpen
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      notificationTag: _withCtx(() => [
        (_ctx.reportStore.getUnreadMessageCount > 0)
          ? (_openBlock(), _createBlock(_component_NotificationTag, {
              key: 0,
              class: "new-tag",
              value: _ctx.reportStore.getUnreadMessageCount?.toString(),
              type: _ctx.NOTIFICATIONTYPES.GREEN
            }, null, 8, ["value", "type"]))
          : _createCommentVNode("", true)
      ]),
      filterMessage: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode(_component_ReportSectionObserver, {
      isOpen: _ctx.isOpen,
      class: "report-messages__content-container",
      markReadFunction: _ctx.reportStore.markMessagesAsRead
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_GenericTableHeaderButton, {
            class: "time-heading",
            label: "Time",
            sortable: false
          }),
          _createVNode(_component_GenericTableHeaderButton, {
            class: "message-heading",
            label: "Message",
            sortable: false
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportStore.report.cadEventCommentResults, (message) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["report-messages__content row", { new: !message.commentRead }]),
            key: message.rowIdentity
          }, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.formatDayMonthTime(message.addedTimestamp)), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(message.commentText), 1)
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["isOpen", "markReadFunction"])
  ]))
}